import * as ClientFormsService from "../../services/clientFormsServices/ClientFormsService";
import { getUserLocations } from "../../services/companiesServices/CompaniesLocationsService";
import {getClockInOut} from "../../services/clockingRecordServices/ClockingRecordService";
import {
 resetTime
} from "../../util/common";

export const getAllClientFormsHandler = async (params) => {
  const response = await ClientFormsService.getAllClientForms(params);

  if (!response.ok) {
    return {
      data: {
        error: "Error getAllClientFormsHandler",
        message: response.data?.message,
        page: null,
      },
    };
  }

 
  return {
    data: {
      error: null,
      page: response.data,
      items: response.data?.content || [],
    },
  };
};

// ---------- EXPORT: GET /api/client-form/export/{fileName}.xlsx ----------
export const exportClientFormsExcelHandler = async (fileName, params) => {
  const response = await ClientFormsService.exportClientFormsExcel(fileName, params);

  if (!response.ok) {
    return {
      data: {
        error: "Error exportClientFormsExcelHandler",
        message: response.data?.message,
      },
    };
  }

  return {
    data: {
      error: null,
      file: response.data,
    },
  };
};

export const createClientFormHandler = async (data) => {


  const body = {
    employeeId: data.employeeId,
    locationId: data.locationId,
    formId: data.formId,
    fields: data.fields || [],

    clientName: data.clientName,
    clientPhone: data.clientPhone,
    clientEmail: data.clientEmail,
    clientSignature: data.clientSignature


  };

  const response = await ClientFormsService.createClientForm(body);

  if (!response.ok) {
    return {
      data: {
        error: response.data?.error || "Error createClientFormHandler",
        message: response.data?.message,
        id: null,
        clientForm: null,
      },
    };
  }

  return {
    data: {
      error: null,
      id: response.data?.id,
      clientForm: response.data || null,
    },
  };
};

// ---------- GET BY ID: /api/client-form/{id} ----------
export const getClientFormByIdHandler = async (id) => {
  const response = await ClientFormsService.getClientFormById(id);

  if (!response.ok) {
    return {
      data: {
        error: "Error getClientFormByIdHandler",
        message: response.data?.message,
        clientForm: null,
      },
    };
  }

  return {
    data: {
      error: null,
      clientForm: response.data || null,
    },
  };
};

// ---------- EDIT: PUT /api/client-form/{id} ----------
export const editClientFormByIdHandler = async (id, data) => {
  const body = {
    id: data.id || id,
    locationId: data.locationId,
    fields: data.fields || [],
    clientName: data.clientName,
    clientPhone: data.clientPhone,
    clientEmail: data.clientEmail,
     clientSignature:data.clientSignature,
   
    employeeSignature: data.employeeSignature,
   
    receipt: data.receipt,
    
  };

  const response = await ClientFormsService.editClientFormById(id, body);

  if (!response.ok) {
    return {
      data: {
        error: "Error editClientFormByIdHandler",
        message: response.data?.message,
      },
    };
  }

  return {
    data: {
      error: null,
      clientForm: response.data || null,
      message: response.data?.message || "Success",
    },
  };
};

// ---------- DELETE: DELETE /api/client-form/{id} ----------
export const deleteClientFormByIdHandler = async (id) => {
  const response = await ClientFormsService.deleteClientFormById(id);

  if (!response.ok) {
    return {
      data: {
        error: "Error deleteClientFormByIdHandler",
        message: response.data?.message,
        ok: false,
      },
    };
  }

  return {
    data: {
      error: null,
      ok: true,
    },
  };
};

// ---------- ME LIST: GET /api/client-form/me ----------
export const getMyClientFormsHandler = async (params) => {
  const response = await ClientFormsService.getMyClientForms(params);

  if (!response.ok) {
    return {
      data: {
        error: "Error getMyClientFormsHandler",
        message: response.data?.message,
        page: null,
      },
    };
  }

  return {
    data: {
      error: null,
      page: response.data,
      items: response.data?.content || [],
      totalCompleted: response.data?.totalCompleted,
    },
  };
};

// ---------- SIGN GET: GET /api/client-form/sign/{id} ----------
export const getClientFormSignByIdHandler = async (id) => {
  const response = await ClientFormsService.getClientFormSignById(id);

  if (!response.ok) {
    return {
      data: {
        error: "Error getClientFormSignByIdHandler",
        message: response.data?.message,
        signForm: null,
      },
    };
  }

  return {
    data: {
      error: null,
      signForm: response.data || null,
    },
  };
};

// ---------- SIGN PUT: PUT /api/client-form/sign/{id} ----------
export const signClientFormByIdHandler = async (id, data) => {
  const body = {
    id: data.id || id,
    clientSignature: data.clientSignature || "",
    fields: data.fields || [],
  };

  const response = await ClientFormsService.signClientFormById(id, body);

  if (!response.ok) {
    return {
      data: {
        error: "Error signClientFormByIdHandler",
        message: response.data?.message,
      },
    };
  }

  return {
    data: {
      error: null,
      signForm: response.data || null,
      message: response.data?.message || "Success",
    },
  };
};



export const getUserLocationsHandler = async () => {
  const response = await getUserLocations();

  if (!response.ok) {
    return {
      data: {
        error: "Error getUserLocationsHandler",
        message: response.data?.message,
        items: [],
      },
    };
  }

  return {
    data: {
      error: null,
      items: response.data || [],
    },
  };
};

// ---------- CLOCK-IN-OUT: GET /api/clock-in-out ----------
export const getClockInOutHandler = async (params) => {
  console.log("getClockInOutHandler: ", params);
  const {
    companyId,
    employeeId,
    timeMin, 
    timeMax, 
    page = 0,
    size = 100000,
    sort, 
  } = params || {};

  if (!companyId || !employeeId) {
    return {
      data: {
        error: null,
        items: [],
        page: null,
      },
    };
  }

  try {
    const start = timeMin || resetTime(new Date());
    const end = timeMax || new Date(start.getTime() + 24 * 60 * 60 * 1000);

    const resp = await getClockInOut(start, end, companyId, { page, size, sort });

    if (!resp?.ok) {
      return {
        data: {
          error: "Error getClockInOutHandler",
          message: resp?.data?.message,
          items: [],
          page: null,
        },
      };
    }

    const pageObj = resp?.data || {};
    const items = pageObj?.content || pageObj?.items || [];

    return {
      data: {
        error: null,
        page: pageObj,
        items: items || [],
      },
    };
  } catch (err) {
    console.error("getClockInOutHandler: ", err);
    return {
      data: {
        error: "Error getClockInOutHandler",
        message: err?.message,
        items: [],
        page: null,
      },
    };
  }
};
